import angular from 'angular';

import CardComponent from './card.cmpt';

export default angular
    .module('application.scene.authorized.scene.dashboard.component.card', [])
    .component(CardComponent.selector, CardComponent);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/dashboard/component/card/index.js